import { Outlet, type RouteObject } from 'react-router-dom';

import MetadataProvider from '@/MetadataProvider';
import { AxiosUserAuthGuard } from '@/axios/hooks/useAxiosTokenEffect';
import { GuestChannelTalkLayout } from '@/layout/GuestLayout';

import { 데모_라우터_루트 } from '../demo/routes';
import { MaintenanceGuard } from '../maintenance/MaintenancePage';
import { 입점유도_라우트_리스트 } from '../manager/영업/영업_라우터';
import { 플랜_게스트_라우터_루트 } from '../plan/routes';

/**
 * 게스트 레이아웃 & 점검 중 못 들어오는 페이지들.
 */
const guestMaintenanceGuardRoutes: RouteObject = {
  element: (
    <MaintenanceGuard disablePassthrough>
      <AxiosUserAuthGuard>
        <MetadataProvider />
        <Outlet />
      </AxiosUserAuthGuard>
    </MaintenanceGuard>
  ),
  children: [
    {
      path: '/signup',
      async lazy() {
        const { default: Page } = await import('@/app/signUp/SignUpPage');
        return {
          Component: Page,
        };
      },
    },
    {
      path: '/signup/cafe24',
      async lazy() {
        const { default: Page } = await import('@/app/signUp/카페24_회원가입');
        return {
          Component: Page,
        };
      },
    },
    {
      path: '/signup/intro',
      async lazy() {
        const { default: Page } = await import('@/app/signUp/회원가입_인트로');
        return {
          Component: Page,
        };
      },
    },
    {
      path: '/signup/cafe24/mallid',
      async lazy() {
        const { default: Page } = await import('@/app/signUp/회원가입_카페24');
        return {
          Component: Page,
        };
      },
    },
    ...플랜_게스트_라우터_루트,
    데모_라우터_루트,
  ],
};

/**
 * 게스트 관련 레이아웃 라우트.
 */
export const guestRoutes: RouteObject = {
  element: <GuestChannelTalkLayout />,
  children: [
    {
      path: '/login',
      async lazy() {
        const { default: Page } = await import('@/app/login/LoginPage');
        return {
          Component: Page,
        };
      },
    },
    guestMaintenanceGuardRoutes,

    ...입점유도_라우트_리스트,
  ],
};
